/** Meta pixel of Sztuki Walki dla Dzieci — Gotowe Treningi (Polish copy): "pixel martial arts pl" 1426143019050867.
 *  NEVER the English (1694960845480040), German (1457228929623029), French (1660443269144667), Italian (975090402319706)
 *  or Dutch (2546249665877855) Martial pixel.
 *  PageView on load, ViewContent when the offer section is seen, InitiateCheckout ONLY on the offer button. */
export const META_PIXEL_ID: string = '1426143019050867';
